<section
  class="pulse-rings"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
>
  <div class="pulse-halo"></div>
  <div class="pulse-core"></div>

  <div
    *ngFor="let ring of rings"
    class="pulse-ring"
    [style.--ring-index]="ring"
  ></div>
</section>
